import React from "react";
import Img from "../images/cashout-mockup.webp";
import { useTranslation } from "react-i18next";

const Agency = () => {
  const { t } = useTranslation();
  return (
    <>
      <section className="agency-section pt-5 pb-0">
        <div className="container detailed-service-section">
          <div className="row align-items-center">
            <div className="col-lg-12 col-md-6 order-md-1 text-center">
              <img src={Img} width="500" height="408"alt="cashout your balance" />
            </div>
            <div className="col-lg-12 col-md-6">
              <div className="bannar-caption">
                <div className="section-heading mb-3">
                  <h2>{t("agency-title")}!</h2>
                </div>
                <p className="paragraph">{t("agency-text")}.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Agency;
